module.exports = __webpack_public_path__ + "static/img/2712_phase_function_Paper_Points.e965c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2712_phase_function_Paper_Points.png
// module id = 4pgJ
// module chunks = 0